module.exports = __webpack_public_path__ + "media/images/background_goals-6898c9272665223777367eeb8a7a62e8.jpg";